import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import EmployeeLeaveLimit from "../../../users/EmployeeLeaveLimit";
import { useLocation } from "react-router-dom";

const LeaveBalanceDetails = ({ leavebalanceDetails }) => {
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");

  const [empLeaveOpen, setEmpLeaveOpen] = useState(false);
  const handleEmpLeaveModalClose = () => {
    setEmpLeaveOpen(false);
  };
  const handleEmpLeaveModalOpen = () => {
    setEmpLeaveOpen(true);
  };

  return (
    <div>
      <Box pb={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Leave Balance of this Month
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Leave type</TableCell>
                        <TableCell align="right">Days</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Casual Leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.casual || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Sick Leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.sick || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Privilege leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.personal || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Permissions
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.permission || 0}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* <Typography color="textSecondary">
                   {leavebalanceDetails?.casual || 0}
                </Typography>
                <Typography color="textSecondary">
                  {leavebalanceDetails?.sick || 0}
                </Typography>
                <Typography color="textSecondary">
                  Privilege leave : {leavebalanceDetails?.personal || 0}
                </Typography>
                <Typography color="textSecondary">
                  Permissions : {leavebalanceDetails?.permission || 0}
                </Typography> */}
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleEmpLeaveModalOpen}
                >
                  Update Leave Details
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
        <EmployeeLeaveLimit
          userId={userId}
          isModalOpen={empLeaveOpen}
          handleModalClose={handleEmpLeaveModalClose}
        />
      </Box>
    </div>
  );
};

export default LeaveBalanceDetails;
